import {Button, Checkbox, DialogActions, DialogContent, FormControlLabel, Grid, TextField} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";

const CreateUpdateModal = (props) => {
    return (
        <>
            <DialogTitle>
                {props.charge.id ? "Update charge " + props.charge.name : "Create a new charge"}
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={1}  sx={{pt:1}}>
                    <Grid xs={12} size={6}>
                        <TextField
                            sx={{m: 0}}

                            label="Name"
                            value={props.charge.name}
                            onChange={(e) => props.setCharge({
                                ...props.charge,
                                "name": e.target.value
                            })}
                            margin="normal"
                            fullWidth
                        />
                    </Grid>
                    <Grid xs={12} size={6}>
                        <TextField
                            sx={{m: 0}}
                            label="Value"
                            value={props.charge.value}
                            onChange={(e) => props.setCharge({
                                ...props.charge,
                                "value": e.target.value
                            })}
                            margin="normal"
                            fullWidth
                        />
                    </Grid>

                    <Grid xs={12} size={6}>
                        <TextField
                            sx={{m: 0}}

                            label="Key"
                            value={props.charge.key}
                            onChange={(e) => props.setCharge({
                                ...props.charge,
                                "key": e.target.value
                            })}
                            margin="normal"
                            fullWidth
                        />
                    </Grid>

                    <Grid xs={12} size={6}>
                        <TextField
                            sx={{m: 0}}

                            label="Guidmap"
                            value={props.charge.guidMap}
                            onChange={(e) => props.setCharge({
                                ...props.charge,
                                "guidMap": e.target.value
                            })}
                            margin="normal"
                            fullWidth
                        />
                    </Grid>

                    <Grid xs={12} size={6}>
                        <TextField
                            sx={{m: 0}}

                            label="Key 2"
                            value={props.charge.key2}
                            onChange={(e) => props.setCharge({
                                ...props.charge,
                                "key2": e.target.value
                            })}
                            margin="normal"
                            fullWidth
                        />
                    </Grid>
                    <Grid xs={12} size={6}>
                        <TextField
                            sx={{m: 0}}

                            label="Guidmap 2"
                            value={props.charge.guidMap2}
                            onChange={(e) => props.setCharge({
                                ...props.charge,
                                "guidMap2": e.target.value
                            })}
                            margin="normal"
                            fullWidth
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid xs={12} size={6}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={props.charge.amount}
                                    onChange={(e) => props.setCharge({
                                        ...props.charge,
                                        "amount": e.target.checked
                                    })}
                                    name="Amount"
                                    color="primary"
                                />
                            }
                            label="Amount"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={props.charge.stringArgs}
                                    onChange={(e) => props.setCharge({
                                        ...props.charge,
                                        "stringArgs": e.target.checked
                                    })}
                                    name="stringArgs"
                                    color="primary"
                                />
                            }
                            label="stringArgs"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={props.charge.supportId}
                                    onChange={(e) => props.setCharge({
                                        ...props.charge,
                                        "supportId": e.target.checked
                                    })}
                                    name="supportId"
                                    color="primary"
                                />
                            }
                            label="supportId"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={props.charge.duration}
                                    onChange={(e) => props.setCharge({
                                        ...props.charge,
                                        "duration": e.target.checked
                                    })}
                                    name="duration"
                                    color="primary"
                                />
                            }
                            label="duration"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={props.charge.endTime}
                                    onChange={(e) => props.setCharge({
                                        ...props.charge,
                                        "endTime": e.target.checked
                                    })}
                                    name="End Time"
                                    color="primary"
                                />
                            }
                            label="End Time"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={props.charge.mephistoTagCheckbox}
                                    onChange={(e) => props.setCharge({
                                        ...props.charge,
                                        "mephistoTagCheckbox": e.target.checked
                                    })}
                                    name="Mephisto Tag"
                                    color="primary"
                                />
                            }
                            label="Mephisto tag"
                        />
                    </Grid>


                    {props.charge.amount==true&&<Grid xs={12} size={12}>
                        <TextField
                            sx={{m: 0}}

                            label="Amount Attribute Name"
                            value={props.charge.amountAttribute}
                            onChange={(e) => props.setCharge({
                                ...props.charge,
                                "amountAttribute": e.target.value
                            })}
                            margin="normal"
                            fullWidth
                        />
                    </Grid>}

                    {props.charge.mephistoTagCheckbox==true&&<Grid xs={12} size={12}>
                        <TextField
                            sx={{m: 0}}

                            label="Mephisto Tag"
                            value={props.charge.mephistoTag}
                            onChange={(e) => props.setCharge({
                                ...props.charge,
                                "mephistoTag": e.target.value
                            })}
                            margin="normal"
                            fullWidth
                        />
                    </Grid>}
                </Grid>

            </DialogContent>

            <DialogActions>
                <Button variant="contained"
                        onClick={props.handleChargeAction}
                >
                    Save
                </Button>

                <Button variant="outlined"
                        onClick={props.handleCancel}
                >
                    Cancel
                </Button>
            </DialogActions>


        </>
    );
}
export default CreateUpdateModal;
